import { useRecentProductsStorage } from './useRecentProductsStorage'

export default useRecentProductsStorage
